const formatPrice = (price) => {
  if (typeof price === 'number') {
    return price.toFixed(2) + ' €'
  } else {
    return ''
  }
}

export default formatPrice
